import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface InfoFieldProps {
  label?: string
  value?: string | number | null
  className?: string
  fallbackText?: string
  customInfo?: ReactNode
  labelClassName?: string
  valueClassName?: string
}

export default function InfoField({ 
  label,
  value, 
  className,
  fallbackText = 'N/A',
  customInfo,
  labelClassName,
  valueClassName
 }: InfoFieldProps) {
  const displayValue = (value === null || value === undefined || String(value).trim() === "") 
    ? fallbackText 
    : value;

  return (
    <div className={twMerge("flex flex-col gap-1 p-2 flex-1 bg-white-100 rounded", className)}>
      {label && <span className={twMerge("text-xs", labelClassName)}>{label}</span>}

      {customInfo ? customInfo : (
        <p className={twMerge("font-bold", valueClassName)}>{displayValue}</p>
      )}
    </div>
  )
}
